import React, { useState } from "react";

const CORRECT_PASSWORD = "chenyuzhang";

export default function PasswordPrompt({
  title = "Password Protected",
  onSuccess,
}) {
  const [inputPassword, setInputPassword] = useState("");
  const [authError, setAuthError] = useState("");

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (inputPassword === CORRECT_PASSWORD) {
      setAuthError("");
      onSuccess();
    } else {
      setAuthError("Incorrect password. Please try again.");
    }
  };

  return (
    <div className="password-overlay">
      <div className="password-modal">
        <h1>{title}</h1>
        <form onSubmit={handlePasswordSubmit} style={{ marginTop: "2rem" }}>
          <input
            type="password"
            className="password-input"
            value={inputPassword}
            onChange={(e) => setInputPassword(e.target.value)}
            placeholder="Enter password"
            required
          />
          <button type="submit" className="password-button">
            Unlock
          </button>
        </form>
        {authError && <p className="error-message">{authError}</p>}
      </div>
    </div>
  );
}
